import styled from "styled-components";

import { theme } from "../styles/theme";

export const ErrorMessage = styled.div`
  color: #ff4242;
  font-size: 0.875rem;
  ${theme.mediumText};
`;
